function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M225.9 97.1c8.1 0 16.2 3.1 22.4 9.3l194.3 194.3c12.4 12.4 12.4 32.4 0 44.8-12.4 12.4-32.4 12.4-44.7 0l-172-172L54 345.4c-12.4 12.4-32.4 12.4-44.7 0-12.4-12.4-12.4-32.4 0-44.8l194.3-194.3c6.1-6.1 14.2-9.2 22.3-9.2z",
  fill: "#221e3e"
});
function SvgArrowUp(_ref) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 451.8 451.8",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
export default __webpack_public_path__ + "cf9891a601167673353cd8a6c5425702.svg";
export { SvgArrowUp as ReactComponent };